import { t } from '@/locales'
import type { TStatusChipVariant } from '@team-milva/lab-components'
import type { TOrderSampleAnalysisStatus } from '@team-milva/lab-models/resources'
import type { Order } from '@/globals/typescript/models/Order'

export function getSampleStatusIndicator(sample: Order['samples'][number]): {
  variant: TStatusChipVariant
  label: string
} {
  if (sample.status === 'cancelled')
    return {
      variant: 'muted',
      label: t('area.order.status.common.cancelled'),
    }
  if (sample.status === 'not-registered')
    return {
      variant: 'blue',
      label: t('area.order.status.sample.not-received'),
    }
  if (sample.status === 'analyses-received')
    return { variant: 'green', label: t('area.order.status.common.done') }
  if (sample.status === 'analyses-received-partially')
    return {
      variant: 'amber',
      label: t('area.order.status.common.in-progress'),
    }

  // status === 'registered' — split into "not started" vs "in progress".
  // An analysis awaiting QA counts as in-progress here too — the "Afventer
  // QA" label itself only surfaces on the analysis row, not the sample.
  const hasStartedAnalysis = sample.analyses.some(
    (a) => a.status === 'started' || a.status === 'awaiting-qa'
  )
  return {
    variant: 'amber',
    label: hasStartedAnalysis
      ? t('area.order.status.common.in-progress')
      : t('area.order.status.common.not-started'),
  }
}

export function getAnalysisStatusChip(status: TOrderSampleAnalysisStatus): {
  variant: TStatusChipVariant
  label: string
} {
  if (status === 'cancelled')
    return {
      variant: 'muted',
      label: t('area.order.status.common.cancelled'),
    }
  if (status === 'awaiting-sample')
    return {
      variant: 'blue',
      label: t('area.order.status.analysis.awaiting-sample'),
    }
  if (status === 'ready-for-processing')
    return {
      variant: 'amber',
      label: t('area.order.status.common.not-started'),
    }
  if (status === 'started' || status === 'received-partially')
    return {
      variant: 'amber',
      label: t('area.order.status.common.in-progress'),
    }
  if (status === 'awaiting-qa')
    return { variant: 'amber', label: t('W: Afventer QA') }
  if (status === 'received')
    return { variant: 'green', label: t('area.order.status.common.done') }
  return { variant: 'neutral', label: status }
}
